import { render } from "./EditDiscount.vue?vue&type=template&id=1c69d9c4"
import script from "./EditDiscount.vue?vue&type=script&lang=js"
export * from "./EditDiscount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__